import React from 'react';
import type { FCWithChildren } from '../../../types/FCWithChildren';

const linkClassname = 'text-blue-600 hover:underline';

export const MarkdownLink: FCWithChildren<{ href?: string }> = ({ children, href }) => {
  if (!href) return null;
  return (
    <a className={linkClassname} target={'_blank'} rel={'noopener noreferrer'} href={href}>
      {children}
    </a>
  );
};
